import {
  AlimentoByMascota,
  AlimentoReq,
  FetchAlimento,
  PesajeReq,
  UpdateAlimento,
} from '../../types/Alimentacion-Pesaje/types';
import { apiRequest } from '../Utils/apiClient';
import {
  ADD_FOOD,
  ADD_WEIGHT,
  GET_A_FOOD,
  GET_FOOD_BAGS,
  GET_FOOD_PET,
} from '../Utils/constants';

const getAlimentos = async (): Promise<FetchAlimento[] | undefined> =>
  (await apiRequest<FetchAlimento[]>('get', GET_FOOD_BAGS)).data;

const getAlimentosByMascota = async (
  id?: string,
): Promise<AlimentoByMascota[] | undefined> =>
  id ? (await apiRequest<AlimentoByMascota[]>('get', `${GET_FOOD_PET}/${id}`)).data : [];

const postAlimento = async (body: AlimentoReq): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('post', ADD_FOOD, body);
    return !!res?.success;
  } catch (error) {
    console.error('❌ [postAlimento]', error);
    return false;
  }
};

const updateAlimento = async (body: UpdateAlimento): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('put', ADD_FOOD, body);
    return !!res?.success;
  } catch (error) {
    console.error('❌ [updateAlimento]', error);
    return false;
  }
};

const deleteAlimento = async (id: number): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('delete', `${GET_A_FOOD}/${id}`);
    return !!res?.success;
  } catch (error) {
    console.error('❌ [deleteAlimento]', error);
    return false;
  }
};

const postPesaje = async (body: PesajeReq): Promise<boolean> => {
  try {
    const res = await apiRequest<boolean>('post', ADD_WEIGHT, body);
    return !!res?.success;
  } catch (error) {
    console.error('❌ [postPesaje]', error);
    return false;
  }
};

export {
  getAlimentos,
  getAlimentosByMascota,
  postAlimento,
  updateAlimento,
  deleteAlimento,
  postPesaje,
};
